<script setup>
import { defineProps, ref } from "vue";
import cart from "@/components/three-in-one/toshiba/shopify-component/add-to-cart/Index.vue";
import checkout from "@/components/three-in-one/toshiba/shopify-component/checkout/Index.vue";
import wtbdialog from "./WhereToBuyDialog.vue";
import esbdialog from "./EmailSubscribeDialog.vue";
import { useDispatchGAEvent } from '@/hooks/common/useDispatchGAEvent';
import { useExposeCsrContext } from '@/hooks/common/use-expose-csr-context';
import { __CONTEXT_WTB_PRODUCT__ } from '@/hooks/common/use-expose-csr-context/constants';

const props = defineProps({
	stateKey: {
		type: String,
		default: "",
	},
	config: {
		type: Object,
		default: () => {
			return {};
		}
	},
	skuInfo: {
		type: Object,
		default: () => {
			return {};
		}
	},
	className: {
		type: String,
		default: "",
	},
	positionInsidePage: {
		type: String,
		default: "",
	},
	 // PAGE_RESULT页面的add-to-cart按钮的ga参数
	searchTerm: {
		type: String,
		default: "",
	},
	shopifyVariant: {
    	type: Object,
		default: () => {},
  	},
});

// eslint-disable-next-line
const dataset = ref({
	className: props.className,
	buttonLabel: props.config.buttonName,
	positionInsidePage: props.positionInsidePage,
	searchTerm: props.searchTerm
});

// eslint-disable-next-line
const stateKey = ref(props.skuInfo.product.productModelNumber + "-btn-" + parseInt(Math.random() * 100000));

const { productModelNumber, productName } = props?.skuInfo?.product??{};

const wtbdialogref = ref(null);

const hideBtn = ref(false);
const handleAemWhereToBuyClick = () => {
	wtbdialogref?.value?.open();
	// useTrackGAEvent(props.config.buttonName, {
	// 	Category: category,
	// 	Subcategory: subcategory,
	// 	ModelNumber: productModelNumber,
	// 	ProductName: productName,
	// 	ProductDetailURL: link,
	// });
	handleGAWhereToBuyClick();
}

const handleGAWhereToBuyClick = () => {
	const gaParams = {
		items: [{
			item_id: productModelNumber, 
			item_name: productName,
		}]
	}
	// 若是page_result页面，还需search_term（搜索关键字）
	if (props?.positionInsidePage === 'search_result') {
		gaParams.search_term = props?.searchTerm;
	}
	useDispatchGAEvent('__GA_WHERE_TO_BUY_CLICK__', gaParams);
	// 暴露product给wtb
	useExposeCsrContext({
		key: __CONTEXT_WTB_PRODUCT__,
		data: {
			product: {
				productModelNumber,
				productName
			}
		}
	});
}
const esbdialogref = ref(null);
const handleEmailSubscribeClick = () => {
	esbdialogref?.value?.open();
}

// other button GA
const handleOtherClick = (e) => {
	useDispatchGAEvent('__GA_CLICK_OTHER_BUTTON__', {
		element: e.target.textContent,
		items: [{
			item_id: productModelNumber,
			item_name: productName
		}],
		current_url: window.location.href,
		landing_url: e.target.href
	});
}

const hanldeHide = () => {
	hideBtn.value = true;
}

</script>

<template>
	<div class="csr-product-btns__item" v-if="!hideBtn">
		<!-- add to cart  -->
		<template v-if="config.buttonFunction === '1'">
			<cart :skuInfo="skuInfo" :dataset="dataset" :stateKey="stateKey" :shopify-variant="shopifyVariant" @btnRenderingFailed="hanldeHide"></cart>
		</template>

		<!-- checkout -->
		<template v-if="config.buttonFunction === '2'">
			<checkout :skuInfo="skuInfo" :dataset="dataset" :stateKey="stateKey" :shopify-variant="shopifyVariant" @btnRenderingFailed="hanldeHide"></checkout>
		</template>

		<!-- where to buy-from aem-->
		<a
			href="javascript:void(0)"
			v-if="config.buttonFunction === '3' && config.retailerListSource === '0'"
			:class="[className]"
			data-action="where-to-buy"
			@click="handleAemWhereToBuyClick"
			:positionInsidePage="positionInsidePage"
		>
			{{ config.buttonName }}
		</a>
		<wtbdialog
			v-if="config.buttonFunction === '3' && config.retailerListSource === '0'"
			ref="wtbdialogref"
			:product="skuInfo?.product??{}"
			:config="config" />

		<!-- email subscribe  -->
		<a
			v-if="config.buttonFunction === '4'"
			href="javascript:void(0)"
			:class="[className]"
			data-action="email-subscribe"
			@click="handleEmailSubscribeClick"
		>
			{{ config.buttonName }}
		</a>
		<esbdialog
			v-if="config.buttonFunction === '4'"
			ref="esbdialogref"
			:product="skuInfo?.product??{}"
			:config="config" />
		<!-- others  -->
		<a
			v-if="config.buttonFunction === '5'"
			:class="[className]"
			:href="config.buttonLink"
			:target="config.buttonLinkTarget"
			rel="noopener noreferrer"
			@click="handleOtherClick"
			>{{ config.buttonName }}</a
		>
	</div>
</template>
